export default __webpack_public_path__ + "static/media/1506.d2e69b2b.png";